import axios from 'axios';


const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true
})

export class BranchOfficeFetchAPI {
    //Function to get branchoffice data by code
    static async getBranchOfficeByCode(business_code, branchoffice_code, token) {
        const res = await server(`/branchoffice/${branchoffice_code}/business/${business_code}`, {
            method: "get",
            headers: token ? { 'x-access-token': token } : undefined,
        });
        return res
    }

    //Function to get branchoffices by business
    static async getBranchOfficesByBusiness(business_id, token) {
        const res = await server(`/business/${business_id}/branchoffice`, {
            method: "GET",
            headers: token ? { 'x-access-token': token } : undefined,
        })
        return res
    }

    //Function to get branchoffices by business
    static async getBranchOfficesByid(branchoffice_id, token) {
        const res = await server(`/branchoffice/${branchoffice_id}`, {
            method: "get",
            headers: token ? { 'x-access-token': token } : undefined,
        })
        return res
    }

      //Function to update branchoffices 
      static async updateBranchoffice(branchoffice_id, data, token) {
        const res = await server(`/branchoffice/${branchoffice_id}`, {
            method: "put",
            data: data,
            headers: token ? { 'x-access-token': token } : undefined,
        })
        return res
    }



}
